import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import FooterLogoSection from './FooterLogoSection';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-[hsl(var(--navy))] to-black text-white w-full">
      <div className="max-w-[1800px] mx-auto px-6 sm:px-8 lg:px-12 py-16">


        <div>
          {/* Top Zone: Logo and Main Navigation */}
          <div className="flex flex-col lg:flex-row justify-between gap-12 pb-10">
            <div className="w-full lg:w-1/3 mb-8 lg:mb-0">
              <FooterLogoSection />
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 w-full lg:w-2/3">
              <div>
                <h4 className="font-semibold mb-4">Platform</h4>
                <ul className="space-y-3 text-sm text-blue-100">
                  <li><Link to="/" className="hover:text-white">Home</Link></li>
                  <li><Link to="/investments" className="hover:text-white">Investments</Link></li>
                  <li><Link to="/how-it-works" className="hover:text-white">How It Works</Link></li>
                  <li><Link to="/education" className="hover:text-white">Education</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold mb-4">Company</h4>
                <ul className="space-y-3 text-sm text-blue-100">
                  <li><Link to="/why-altax" className="hover:text-white">Why ALTA-X</Link></li>
                  <li><Link to="/about" className="hover:text-white">About</Link></li>
                  <li><Link to="/press" className="hover:text-white">Press</Link></li>
                  <li><Link to="/careers" className="hover:text-white">Careers</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold mb-4">Resources</h4>
                <ul className="space-y-3 text-sm text-blue-100">
                  <li><Link to="/help-center" className="hover:text-white">Help Center</Link></li>
                  <li><a href="http://news.alta-x.com/" target="_blank" rel="noopener noreferrer" className="hover:text-white">Blog</a></li>
                  <li><a href="https://alta-x.com/" target="_blank" rel="noopener noreferrer" className="hover:text-white">Webinars</a></li>
                  <li><a href="https://alta-x.com/" target="_blank" rel="noopener noreferrer" className="hover:text-white">Support</a></li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold mb-4">Legal</h4>
                <ul className="space-y-3 text-sm text-blue-100">
                  <li><Link to="/fsca-compliance" className="hover:text-white">FSCA Compliance</Link></li>
                  <li><Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link></li>
                  <li><Link to="/terms-of-service" className="hover:text-white">Terms of Service</Link></li>
                  <li><a href="https://www.fsca.co.za/" target="_blank" rel="noopener noreferrer" className="hover:text-white">FSCA Website</a></li>
                </ul>
              </div>
            </div>
          </div>

          {/* Middle Zone: Connect and Disclaimer */}
          <div className="border-t border-white/10 py-10 flex flex-col lg:flex-row justify-between gap-12">
            <div className="w-full lg:w-1/4">
              <h4 className="font-semibold mb-4">Connect</h4>
              <div className="flex space-x-4 mb-4">
                <a href="https://www.facebook.com/profile.php?id=61575284894950&sk=about" target="_blank" rel="noopener noreferrer"><Facebook className="w-5 h-5 text-blue-100 hover:text-white" /></a>
                <a href="https://x.com/AltaXofficial" target="_blank" rel="noopener noreferrer"><Twitter className="w-5 h-5 text-blue-100 hover:text-white" /></a>
                <a href="https://linkedin.com/company/alta-x" target="_blank" rel="noopener noreferrer"><Linkedin className="w-5 h-5 text-blue-100 hover:text-white" /></a>
                <a href="https://instagram.com/x.alta" target="_blank" rel="noopener noreferrer"><Instagram className="w-5 h-5 text-blue-100 hover:text-white" /></a>
              </div>
              <div className="text-sm text-blue-100 space-y-2">
                <p>33 Ballyclare Drive, Sandton, 2191</p>
                <a href="mailto:info@alta-x.com" className="hover:text-white block">info@alta-x.com</a>
                <a href="tel:+27100075725" className="hover:text-white block">+27 10 007 5725</a>
              </div>
            </div>
            <div className="w-full lg:w-3/4 text-xs text-blue-200 leading-relaxed space-y-4">
              <p>
                ALTA-X and ALTA.X.COM are products of 1st Group Capital (Pty) Ltd, an authorized financial services provider (FSP 49632). All investments made through the ALTA.X platform are subject to the legal terms and conditions, which you agree to adhere to upon engaging with the platform.
              </p>
              <p>
                Regarding FSRs, ALTA-X acts as the principal in a contract for difference (CFD) issued to the investor. This allows the investor to gain exposure to the economic benefits and risks of share ownership, such as price movements and dividends, without actual ownership of the underlying shares.
              </p>
              <p>
                All client funds are held in a segregated trust account with a major South African bank, ensuring that your money is protected and kept separate from our operational funds.
              </p>
            </div>
          </div>

          {/* Bottom Zone: Copyright */}
          <div className="border-t border-white/10 pt-10 flex flex-col md:flex-row justify-between items-center text-sm text-blue-200">
            <p>&copy; {new Date().getFullYear()} ALTA-X. All rights reserved.</p>
            <p className="mt-4 md:mt-0">A product of 1st Group Capital (Pty) Ltd</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
